/** localStorage for Q7.6 — likelihood to mention product (single select). */
export const Q7_6_STORAGE_KEY = 'npdsurvey:q7_6';

export const Q7_6_OPTIONS = [
  'Very likely',
  'Somewhat likely',
  'Not very likely',
  'Not at all likely',
  'Not sure',
] as const;

export type Q7_6Option = (typeof Q7_6_OPTIONS)[number];

export type Q7_6Answers = {
  selected: Q7_6Option;
};

function isQ7_6Option(v: unknown): v is Q7_6Option {
  return typeof v === 'string' && (Q7_6_OPTIONS as readonly string[]).includes(v);
}

export function readQ7_6Answers(): Q7_6Answers | null {
  try {
    const raw = localStorage.getItem(Q7_6_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const selected = (o as { selected?: unknown }).selected;
    if (isQ7_6Option(selected)) {
      return { selected };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeQ7_6Answers(data: Q7_6Answers): void {
  try {
    localStorage.setItem(Q7_6_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_6Answers(): void {
  try {
    localStorage.removeItem(Q7_6_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_6Complete(): boolean {
  return readQ7_6Answers() != null;
}
